export default [
  {
    path: "/platformConfigurations/paymentProviders",
    component: () => import(/* webpackChunkName: "layout" */ "../layout"),

    children: [
      {
        path: ":id",
        props: true,
        name: "platform.paymentProviders.show",
        component: () =>
          import(/* webpackChunkName: "platform.paymentProviders.show" */ "./show.vue"),
      },
    ],
  },
];
